import GeneralSuite from './GeneralSuite';

export default GeneralSuite;